import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import RoleList from "@/admin/components/settings/roles/RoleList";
import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_settings/settings/roles/")(
  {
    component: RouteComponent,
    beforeLoad: ({ context }) => {
      throwIfHasNoPermission(context.user, "core.role.view");

      return {} satisfies ChildRouteContext;
    },
  },
);

function RouteComponent() {
  const { t } = useTranslation("core.shared");

  return (
    <Container
      title={t("Manage Roles")}
      description={t("Manage create and edit roles")}
    >
      <RoleList />
    </Container>
  );
}
